import { getPluralOrSingular } from '../helpers'

function formatDuration(value) {
  if (!value) return ''
  const [hours, minutes] = value.split(':').map(i => parseInt(i))

  let str

  const hourStr = getPluralOrSingular('Hour', hours)
  const minutesStr = getPluralOrSingular('Minute', minutes)

  if (hours) {
    if (minutes) {
      str = `${hourStr} ${minutesStr}`
    } else str = `${hourStr}`
  } else str = `${minutesStr}`

  return str
}

export function formatAssignmentTitle(title, shortTitle) {
  if (!shortTitle || shortTitle === title) return title

  return `${shortTitle}: ${title}`
}

export function truncateString(str, length = 20) {
  if (typeof str !== 'string' || typeof length !== 'number') return str
  return str.length > length ? str.substring(0, length - 1) + '...' : str
}

export default {
  filters: {
    formatDuration,
    truncateString,
    formatAssignmentTitle,
  },
}
